<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ISfISw/tc-custom/9781627881821.jpg?1730747856902" alt="This image is the cover for the book 200 Low-Carb High-Fat Recipes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">200 Low-Carb High-Fat Recipes
      </h1>
      <p class="bookDescription body article font2">
        <b>Discover how to drop the pounds permanently with this ketogenic diet cookbook.</b><br/><br/>You’ve hit it before—the dreaded weight-loss plateau that you just can’t break through. No matter what, the pounds won’t go even with calorie counting and traditional low-carb diets. Turns out there is a secret weapon to losing weight—fat (and lots of it). After decades of taking butter, bacon, eggs, and avocados off the table, it turns out that fats are far better for beating the battle of the bulge than “healthy whole grains” and high protein diets. Backed up by science, the LCHF diet is quickly becoming the hottest way to shed pounds and jumpstart a stalled metabolism.<br/><br/>Low-carb proponent and bestselling author Dana Carpender will guide you through the LCHF lifestyle and shed light on important questions such as:Is LCHF safe?Why does the traditional low-carb, high-protein diet not work for you?Which Are Good Fats? (Not all fats are created equal!)<br/><br/>In <i>200 Low-Carb, High-Fat Recipes</i> you get tips for creating low-carb/high-fat meals, and find out why three meals a day may not be needed! With 200 recipes, including soups, breakfasts, appetizers, sides and sauces, you’ll never be cooked for delicious ideas!<br/><br/><b>Praise for <i>200 Low-Carb High-Fat Recipes</i></b><br/><br/>“If you are among the nutritionally enlightened, rejecting the outdated and destructive ‘cut your fat and eat more healthy whole grains’ message, and have ambitions for a sumptuous return to duck fat, lard, bacon fat, and coconut milk and doing it in style, then Dana’s new book is right up your alley.” —William Davis, M.D., author of #1<i> New York Times</i>–bestseller<i> Wheat Belly</i><br/><br/>“Fat is back and better than ever. Real food-based fats like butter, coconut oil, steak, cream, and cheese, are essential to help you burn fat, zap hunger and cravings, and optimize your health in ways you never thought possible. If you want to be in a state of nutritional ketosis, <i>200 Low-Carb, High-Fat Recipes</i> is your new go-to resource.” —Jimmy Moore, author of<i> Cholesterol Clarity </i>and <i>Keto Clarity</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dana Carpender
      </h2>
      
      <p class="authorDescription body article">Dana Carpender (Bloomington, Indiana) is a pioneer of the low-carb movement and best-selling author of over 14 cookbooks, including The New 500 Low-Carb Recipes,1001 Low-Carb Recipes, 500 Paleo Recipes, 15-Minute Low-Carb Recipes, The Low-Carb Diabetes Solution Cookbook, 200 Low-Carb, High-Fat Recipes, The Low-Carb Diabetes Solution, The Insulin Resistance Solution, 500 Ketogenic Recipes, and many more. To date, her books have sold over a million copies worldwide. She writes about low-carb cooking and nutrition on her Facebook page, Dana Carpender's Hold the Toast Press.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Fair Winds Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7b5e60c6